<script>
  import { Modal } from 'bootstrap';
  import { getContext, onMount } from 'svelte';
  import Loader from '../components/Loader.svelte';
  export let handleClick = (e) => {};
  let reason = '';
  let changePriorityModal;
  let isLoading = false;
  onMount(() => {
    changePriorityModal = new Modal(document.getElementById('changePriorityModal'), {
      keyboard: false,
    });
  });
  import * as yup from 'yup';
  export let success = () => {};
  export const show = (data) => {
    isLoading = false;
    $form = data;
    changePriorityModal.show();
  };
  export const showModal = () => {
    reason = '';
    changePriorityModal.show();
  };
  const showDialog = getContext('showDialog');
  let defaultValue = {
    priority: '',
    tasks: [],
  };
  import { createForm } from 'svelte-forms-lib';
  import { client } from 'root/api/index.js';
  import { configItem, getValueBySearchValue } from './Helper';
  import DropDown from './DropDown.svelte';
  const { form, errors, handleChange, handleSubmit } = createForm({
    initialValues: { ...defaultValue },
    validationSchema: yup.object().shape({
      priority: yup.string().required('Please select priority'),
    }),
    onSubmit: (values) => {
      client
        .taskChangePriority(values)
        .then(async (result) => {
          changePriorityModal.hide();
          success();
        })
        .catch((error) => {
          showDialog({
            message: `${error}`,
            okFunc: () => {
              isLoading = false;
              showModal();
            },
          });
          changePriorityModal.hide();
        });
    },
  });
</script>

<!-- Modal -->
<div
  class="modal fade"
  id="changePriorityModal"
  tabindex="-1"
  aria-labelledby="changePriorityModal"
  aria-hidden="true"
>
  <div class="modal-dialog modal-sm shadow">
    {#if isLoading}
      <div class="modal-content p-5 text-center">
        <div class="p-5">
          <Loader Style="loader-block" />
        </div>
      </div>
    {:else}
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title font-size-14"
            id="exampleModalLabel"
          >
            Change Priority
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="col-md-12">
            <div class="form-group position-relative priority-dropdown-modal">
              <DropDown
                dropdownId="bulkPriority"
                showIcon={true}
                checkbox={false}
                deleteSelected={false}
                active={true}
                titleChanged={true}
                title={getValueBySearchValue(
                  configItem.priority,
                  'id',
                  form.priority,
                  'name',
                  'Priority',
                )}
                on:onSelect={(item) => {
                  $form.priority = item.detail.id;
                }}
                option={configItem.priority}
                Style="select-block priority-dropdown"
              />
              {#if $errors.dateType}
                <label
                  class="formError"
                  style="top: 8px;bottom: auto;"
                  for="reason">{$errors.dateType}</label
                >
              {/if}
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel font-size-12"
            data-bs-dismiss="modal">Cancel</button
          >
          <button
            type="button"
            class="btn btn-primary m-0 px-4 font-size-12"
            on:click={() => {
              isLoading = true;
              handleSubmit();
            }}>Done</button
          >
        </div>
      </div>
    {/if}
  </div>
</div>

<style lang="scss">
  .shadow {
    box-shadow: 0 0 30px 0 rgba(82, 63, 105, 0.05);
  }
  .active,
  .active:hover {
    background-color: $blue-color;
    color: $white-color;
    border: 1px solid $blue-color;
  }
</style>
